module.exports = __webpack_public_path__ + "img/weixin.cfd2f4bf.jpg";